/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
*/

import gql from "graphql-tag";

export const GET_USER_WITH_BOXES = gql`
query GetUsersWithBoxes($presentationId: MID!, $filter: UserAndBoxesFilterInput, $options: GetManyOptions, $invitedByUser: MID) {
  getUsersWithBoxes(presentationId: $presentationId, filter: $filter, options: $options, invitedByUser: $invitedByUser) {
    content {
      Referal {
        inviteType
        partition
      }
      email
      Boxes {
        id
        totalAmount
        totalAmountInUSD
        section {
          name
          costumeTypes {
            name
            id
          }
        }
        presentation {
          name
        }
        costumeID
        discount {
          sponserName
          lateAssociation
          type
          discountAmount
        }
        boxStatus
        boxTxes {
          reason
          displayTitle
        }
        amountPaid
        paymentStats
        items {
          costumeAttribute {
            id
            name
          }
          costumeFeature {
            name
            id
          }
          costumeType {
            name
            id
          }
        }
      }
      firstName
      fullName
      gender
      userId
      creatorUser {
        fullName
        email
      }
      id
      lastName
      vuid
      accountStatus
    }
    count
    limit
    skip
  }
}
`;
